/* Reef Lagoon — Stockists preview reveal.
 * Minimal progressive enhancement for sections/reef-stockists.liquid: fades + rises the
 * section once on scroll-in (transform/opacity only), gated behind prefers-reduced-motion.
 * Idempotent; re-inits on shopify:section:load. The homepage map is decorative — no map library. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    if (!root || root.dataset.rskInit === '1') return;
    root.dataset.rskInit = '1';

    if (REDUCE || !('IntersectionObserver' in window)) { root.classList.add('is-in'); return; }

    root.classList.add('rsk--observe');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    io.observe(root);
  }

  function initAll() {
    var els = document.querySelectorAll('[data-rsk]');
    for (var i = 0; i < els.length; i++) initReveal(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-rsk]') : null;
    if (el) { initReveal(el); } else { initAll(); }
  });
})();
